import { ArrowDownward } from "@mui/icons-material";
import { List, ListItem, CircularProgress } from "@mui/material";
import React from "react";

import CustomIconButton from "../../../../ui library/components/buttons/CustomIconButton";

export default function CustomListBox(props) {
  const { children, showMore, setShowMore, loading, ...other } = props;

  const childrenWithKeys = React.Children.map(children, (child, i) =>
    React.cloneElement(child, { key: `element-${i}` })
  );

  return (
    <List {...other}>
      {childrenWithKeys}
      {showMore && (
        <ListItem className="flex w-full flex-row justify-center">
          {loading ? (
            <CircularProgress size={24} />
          ) : (
            <CustomIconButton
              iconVisible
              tooltipText="Show More"
              icon={<ArrowDownward />}
              handleOnClick={() => setShowMore(true)}
            />
          )}
        </ListItem>
      )}
    </List>
  );
}
